export default __webpack_public_path__ + "fonts/ubuntu-latin-400-normal-933b7e.woff";